export default __webpack_public_path__ + "static/media/book8.4f84b3c3.svg";